"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResumableUploader = void 0;
var fs = require("fs");
var Stream = require("stream");
var logger_1 = require("../../utils/deprecated/logger");
var upload_configuration_request_1 = require("./requests/upload-configuration-request");
var upload_configuration_response_1 = require("./responses/upload-configuration-response");
var tus = require("tus-js-client");
/**
 * @param {Configuration} configuration
 * @param {HTTPClient} httpClient
 * @constructor
 */
var ResumableUploader = /** @class */ (function () {
    function ResumableUploader(configuration, httpClient, logger) {
        if (logger === void 0) { logger = logger_1.dummyLogger; }
        this.configuration = configuration;
        this.httpClient = httpClient;
        this.logger = logger;
        this.apiUrl = 'https://' + configuration.domain + '/_api/v3/upload';
    }
    /**
     * @description retrieve upload configuration for uploading files
     * @param uploadConfigurationRequest
     */
    ResumableUploader.prototype.getUploadConfiguration = function (uploadConfigurationRequest) {
        return this.httpClient
            .post(this.apiUrl + '/configuration', uploadConfigurationRequest)
            .then(function (response) {
            return new upload_configuration_response_1.UploadConfigurationResponse(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * @description upload a file (v3)
     * @param {string} path the destination to which the file will be uploaded
     * @param {string|Buffer|Stream} file can be one of: string - path to file, memory buffer, stream
     * @param {UploadFileRequest?} uploadFileRequest
     * @param {string?} _uploadUrl (unsupported in resumable upload)
     * @param {ResumableUploadCallbackHandler} callbackHandler
     */
    ResumableUploader.prototype.uploadFile = function (path, file, uploadFileRequest, _uploadUrl, callbackHandler) {
        return __awaiter(this, void 0, void 0, function () {
            var stream, size, uploadConfigurationRequest, uploadConfiguration, fileDescriptor;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        stream = file, size = null;
                        uploadConfigurationRequest = ResumableUploader.createUploadConfigurationRequest(path, size, uploadFileRequest);
                        this.logger.debug("uploadConfigurationRequest: " + JSON.stringify(uploadConfigurationRequest));
                        return [4 /*yield*/, this.getUploadConfiguration(uploadConfigurationRequest)];
                    case 1:
                        uploadConfiguration = _a.sent();
                        this.logger.debug("uploadConfigurationResponse: " + JSON.stringify(uploadConfiguration));
                        if (!uploadConfiguration.uploadUrl) {
                            return [2 /*return*/, Promise.reject('No `getUploadConfiguration` response')];
                        }
                        this.logger.debug("Uploading file to " + uploadConfiguration.uploadUrl);
                        return [4 /*yield*/, this.uploadFileWithTus(uploadConfiguration, stream, uploadFileRequest, callbackHandler)];
                    case 2:
                        fileDescriptor = _a.sent();
                        return [2 /*return*/, [fileDescriptor]];
                }
            });
        });
    };
    ResumableUploader.createUploadConfigurationRequest = function (path, size, uploadFileRequest) {
        var acl, mimeType;
        if (uploadFileRequest) {
            (acl = uploadFileRequest.acl, mimeType = uploadFileRequest.mimeType);
        }
        return new upload_configuration_request_1.UploadConfigurationRequest({
            path: path,
            size: size,
            acl: acl,
            mimeType: mimeType,
            protocol: upload_configuration_request_1.UploadProtocol.TUS,
        });
    };
    ResumableUploader.prototype.uploadFileWithTus = function (uploadConfiguration, fileObject, uploadFileRequest, callbackHandler) {
        return __awaiter(this, void 0, void 0, function () {
            var params, uploadUrl, uploadToken, logger, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {};
                        uploadUrl = uploadConfiguration.uploadUrl, uploadToken = uploadConfiguration.uploadToken;
                        params.token = uploadToken;
                        params.contentType =
                            (uploadFileRequest === null || uploadFileRequest === void 0 ? void 0 : uploadFileRequest.mimeType) || 'application/octet-stream';
                        if (uploadFileRequest === null || uploadFileRequest === void 0 ? void 0 : uploadFileRequest.acl) {
                            params.acl = uploadFileRequest.acl;
                        }
                        if (uploadFileRequest === null || uploadFileRequest === void 0 ? void 0 : uploadFileRequest.lifecycle) {
                            params.lifecycle = uploadFileRequest.lifecycle;
                        }
                        if (uploadFileRequest === null || uploadFileRequest === void 0 ? void 0 : uploadFileRequest.fileName) {
                            params.fileName = uploadFileRequest.fileName;
                        }
                        logger = this.logger;
                        return [4 /*yield*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                var uploadSession, previousUploads;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            uploadSession = new tus.Upload(fileObject, {
                                                endpoint: uploadUrl,
                                                retryDelays: [0, 3000, 5000, 10000, 20000],
                                                metadata: params,
                                                chunkSize: 5 * 1024 * 1024,
                                                onError: function (error) {
                                                    logger.error(error.message);
                                                    (callbackHandler === null || callbackHandler === void 0 ? void 0 : callbackHandler.onError) && callbackHandler.onError(error);
                                                    reject(error);
                                                },
                                                onProgress: function (bytesUploaded, bytesTotal) {
                                                    (callbackHandler === null || callbackHandler === void 0 ? void 0 : callbackHandler.onProgress) &&
                                                        callbackHandler.onProgress(bytesUploaded, bytesTotal);
                                                    var percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
                                                    logger.debug(bytesUploaded + "/" + bytesTotal + ", " + percentage + "%");
                                                },
                                                onSuccess: function () {
                                                    (callbackHandler === null || callbackHandler === void 0 ? void 0 : callbackHandler.onSuccess) && callbackHandler.onSuccess();
                                                    resolve();
                                                },
                                            });
                                            return [4 /*yield*/, uploadSession.findPreviousUploads()];
                                        case 1:
                                            previousUploads = _a.sent();
                                            if (previousUploads.length) {
                                                uploadSession.resumeFromPreviousUpload(previousUploads[0]);
                                            }
                                            uploadSession.start();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        delete params.token;
                        return [4 /*yield*/, this.httpClient.put(uploadUrl + "/" + uploadToken, params)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result.payload];
                }
            });
        });
    };
    ResumableUploader.normalizeStream = function (file) {
        var stream;
        var size = null;
        if (ResumableUploader.isStream(file)) {
            throw new Error('Stream is not supported with resumable upload');
        }
        if (typeof file === 'string') {
            try {
                size = fs.statSync(file).size;
            }
            catch (error) {
                throw error;
            }
            stream = file;
        }
        else if (ResumableUploader.isBuffer(file)) {
            // noinspection JSUnresolvedVariable
            stream = file;
        }
        else {
            throw new Error('unsupported source type: ' + typeof file);
        }
        return { size: size, stream: stream };
    };
    ResumableUploader.isBuffer = function (file) {
        try {
            return file instanceof Buffer;
        }
        catch (_) {
            return false;
        }
    };
    ResumableUploader.isStream = function (file) {
        try {
            return file instanceof Stream && typeof file.pipe === 'function';
        }
        catch (_) {
            return false;
        }
    };
    return ResumableUploader;
}());
exports.ResumableUploader = ResumableUploader;
//# sourceMappingURL=resumable-uploader.js.map